import axios from "axios";

// export const HOST_API = "http://localhost:3017";
export const HOST_API = "https://belenbai.mn";
export const REACT_APP_API_BASE_URL = `${HOST_API}/api`;
// export const REACT_APP_API_BASE_URL = "https://belenbai.mn/api/v1";

const apiClient = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use();

export default apiClient;
